import { ErrorCode } from '@kreart/shared';
import { makeErrorKeyResolver } from '@/lib/form/errorMessages';

export const errorKeyFor = makeErrorKeyResolver({
  [ErrorCode.CLIENTS_NOT_FOUND]: 'clients.errors.notFound',
  [ErrorCode.CLIENTS_HAS_PROJECTS]: 'clients.errors.hasProjects',
  [ErrorCode.CLIENTS_DELIVERY_ADDRESS_NOT_FOUND]: 'clients.errors.addressNotFound',
  [ErrorCode.NOT_FOUND]: 'clients.errors.notFound',
});
